import { FC } from "react";

interface CardDescriptionProps {
    description?: string;
    descriptionId?: string;
}

const CardDescription: FC<CardDescriptionProps> = ({
    description,
    descriptionId,
}) => {
    if (!description) return null;

    return (
        <div id={descriptionId} className="card-description">
            {description}
        </div>
    );
};

export default CardDescription;
